import i18n from 'i18next';

/**
 * Liczba wg aktualnego języka. Zastępuje `toLocaleString('en-US')`, które na sztywno
 * wstawiało przecinek tysięcy. Po polsku 12345 to „12 345" (twarda spacja), a 1284 to
 * „1284": reguła CLDR dla `pl` nie grupuje liczb czterocyfrowych.
 */
export const formatNumber = (value: number, options?: Intl.NumberFormatOptions) =>
  new Intl.NumberFormat(i18n.language, options).format(value);
